import * as axios from 'axios';
import { API } from '@/shared/config';

const parseList = (response) => {
  if (response.status !== 200) throw Error(response.message);
  if (!response.data) return [];
  let list = response.data;
  if (typeof list !== 'object') {
    list = [];
  }
  return list;
};

const getMotorData = async () => {
  try {
    const response = await axios.get(`${API}/zcp/motor/motorload`);
    console.log(response);
    const data = parseList(response);
    return data;
  } catch (error) {
    return {};
  }
};

const searvhVehicle = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/vehiclesearch`, data);
    console.log(response);
    const vehicle = parseList(response);
    return vehicle;
  } catch (error) {
    return {};
  }
};

const motorGetModel = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/getmodel`, data);
    console.log(response);
    const model = parseList(response);
    return model;
  } catch (error) {
    return {};
  }
};

const motorGetManufacturer = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/getmake`, data);
    console.log(response);
    const make = parseList(response);
    return make;
  } catch (error) {
    return {};
  }
};

const motorCalculation = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/motorcalc`, data);
    console.log(response);
    const packages = parseList(response);
    return packages;
  } catch (error) {
    return [];
  }
};

const motorQuotation = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/motorquotation`, data);
    console.log(response);
    const packages = parseList(response);
    return packages;
  } catch (error) {
    return [];
  }
};

const motorPackageCalculation = async (data) => {
  try {
    const response = await axios.post(`${API}/zcp/motor/motorpckcalc`, data);
    console.log(response);
    const packages = parseList(response);
    return packages;
  } catch (error) {
    return [];
  }
};

const validateEmail = async (data) => {
  try {
    console.log(data);
    await axios.post(`${API}/zcp/otp/generate`, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const validateOtp = async (data) => {
  try {
    console.log(data);
    await axios.post(`${API}/zcp/otp/validate`, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const validateRules = async (data) => {
  try {
    console.log(data);
    await axios.post(`${API}/zcp/log/validations`, data);
    // return true;
  } catch (error) {
    console.log(error);
    // return false;
  }
};

const languageReset = async (data) => {
  try {
    console.log(data);
    // await axios.post(`${API}/zcp/motor/languagereset`, data);
    // return true;
  } catch (error) {
    console.log(error);
    // return false;
  }
};

const dataServices = {
  getMotorData,
  searvhVehicle,
  motorGetModel,
  motorGetManufacturer,
  motorCalculation,
  motorQuotation,
  motorPackageCalculation,
  validateEmail,
  validateOtp,
  validateRules,
  languageReset
};

export default dataServices;
